<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:introduction-content="page.introductionContent"
		/>

		<section class="main-content background-light packages-section">
			<div class="row">
				<div class="grid">
					<nuxt-link
						v-for="item in packagesData"
						:key="item.ID"
						:to="localePathNormalized(item.filename)"
						class="block-item white"
					>
						<div class="block-item-content">
							<h3>{{ item.header }}</h3>
							<div v-parse-links v-html="item.overviewContent" />
							<span class="button-no-fill">{{ defaults[locale].packages.view }}</span>
						</div>
						<picture>
							<source v-if="item.overviewImageWebp" :srcset="item.overviewImageWebp" type="image/webp" />
							<source :srcset="item.overviewImage" />
							<img loading="lazy" :src="item.overviewImage" :alt="item.overviewImageAlt" />
						</picture>
					</nuxt-link>
				</div>
			</div>
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			class="faq-section"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePathNormalized = useLocalePathNormalized();

await fetchPage();
await fetchDefaults();

const { data: packagesData } = await useWebsiteFetch('packages', {
	query: { language: locale.value },
	key: `${locale.value}/packages`,
});
</script>

<style lang="scss" scoped>
.grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 30px;
}

.packages-section .block-item {
	&:hover {
		color: #fff;
	}
}

.block-item {
	width: 100%;
	overflow: hidden;
	border-radius: 45px 45px 0 0;
}

.block-item-content {
	color: #fff;

	p,
	:deep(p) {
		color: #fff !important;
	}
}

.event-date {
	color: #fff;
	font-size: 14px;
	margin: 0 0 10px;
	display: inline-block;
	width: 100%;
	letter-spacing: 2px;
}

@media (max-width: 1080px) {
	.grid {
		grid-template-columns: repeat(2, 1fr);
	}
}

@media (max-width: 750px) {
	.grid {
		grid-template-columns: 1fr;
	}
}
</style>
